import { useEffect, useState } from "react";
import { getOfferte } from "@/lib/api";
import { OfferCard } from "@/components/OfferCard";
import { Reveal } from "@/components/Reveal";

export const OffersGrid = ({ target, title, subtitle, exclude, testId = "offers-grid", limit = 8, ivaInclusa = false, similarTo = null }) => {
  const [offerte, setOfferte] = useState([]);

  useEffect(() => {
    getOfferte(target)
      .then((data) => {
        let list = exclude ? data.filter((o) => `${o.slug_marca}/${o.slug_modello}` !== exclude) : data;
        list = similarTo != null
          ? [...list].sort((a, b) => Math.abs((a.canone ?? 999999) - similarTo) - Math.abs((b.canone ?? 999999) - similarTo))
          : [...list].sort((a, b) => (b.vetrina ? 1 : 0) - (a.vetrina ? 1 : 0) || (a.vetrina_ordine ?? 999) - (b.vetrina_ordine ?? 999) || (a.canone ?? 999999) - (b.canone ?? 999999));
        setOfferte(list.slice(0, limit));
      })
      .catch(() => setOfferte([]));
  }, [target, exclude, limit, similarTo]);

  if (!offerte.length) return null;

  return (
    <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20" data-testid={testId}>
      {title && (
        <Reveal>
          <h2 className="max-w-2xl font-display text-3xl font-bold text-xmove-ink sm:text-4xl" data-testid={`${testId}-title`}>{title}</h2>
          {subtitle && <p className="mt-3 max-w-2xl text-base text-xmove-muted md:text-lg">{subtitle}</p>}
        </Reveal>
      )}
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {offerte.map((o, i) => (
          <Reveal key={`${o.slug_marca}-${o.slug_modello}`} delay={(i % 4) * 0.08} className="h-full">
            <OfferCard offer={o} ivaInclusa={ivaInclusa} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};
